import React from "react";
import { Pencil, Star, Check } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import Reveal from "./Reveal";
import { capture } from "../mock";

const iconMap = { Pencil, Star, Check };

const Missions = () => {
  return (
    <section id="missions" className="bg-white py-16 lg:py-20">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal className="flex justify-center">
          <PhoneMockup src={capture.image} alt="Capture des missions VÉLIS" width={220} />
        </Reveal>

        <div>
          <Reveal>
            <h2 className="font-display font-extrabold text-[#14141a] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              {capture.title}
            </h2>
            <p className="mt-5 text-[#5a5a66] text-lg leading-relaxed max-w-lg">{capture.subtitle}</p>
          </Reveal>

          <div className="mt-8 space-y-4">
            {capture.items.map((item, i) => {
              const Icon = iconMap[item.icon];
              return (
                <Reveal key={item.title} delay={i * 120}>
                  <div className="flex items-center gap-4">
                    <div className="shrink-0 w-11 h-11 rounded-full bg-[var(--velis-orange)] flex items-center justify-center shadow-md shadow-orange-900/20">
                      <Icon className="text-white" size={20} />
                    </div>
                    <span className="font-display font-semibold text-[#14141a] text-lg">{item.title}</span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Missions;
